/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserEmailsDto
 */
export interface UserEmailsDto {
    /**
     * List of user emails to fetch events for
     * @type {Array<string>}
     * @memberof UserEmailsDto
     */
    emails: Array<string>;
}

/**
 * Check if a given object implements the UserEmailsDto interface.
 */
export function instanceOfUserEmailsDto(value: object): value is UserEmailsDto {
    if (!('emails' in value) || value['emails'] === undefined) return false;
    return true;
}

export function UserEmailsDtoFromJSON(json: any): UserEmailsDto {
    return UserEmailsDtoFromJSONTyped(json, false);
}

export function UserEmailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEmailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'emails': json['emails'],
    };
}

export function UserEmailsDtoToJSON(json: any): UserEmailsDto {
    return UserEmailsDtoToJSONTyped(json, false);
}

export function UserEmailsDtoToJSONTyped(value?: UserEmailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emails': value['emails'],
    };
}

